import { computed, ref } from 'vue'

type SessionExpiredListener = (loginUrl: string) => void

const sessionExpired = ref(false)
const loginUrl = ref('/Account/Login')
const listeners = new Set<SessionExpiredListener>()

export class SessionExpiredError extends Error {
  constructor(message = 'Session expired') {
    super(message)
    this.name = 'SessionExpiredError'
  }
}

export const isSessionExpired = computed(() => sessionExpired.value)
export const sessionExpiredLoginUrl = computed(() => loginUrl.value)

export function isSessionExpiredError(error: unknown): error is SessionExpiredError {
  return error instanceof SessionExpiredError
}

export function buildSessionExpiredLoginUrl(location: Location = window.location) {
  const returnUrl = `${location.pathname}${location.search}${location.hash}`
  const params = new URLSearchParams({ returnUrl })
  return `/Account/Login?${params.toString()}`
}

export function expireSession(url = buildSessionExpiredLoginUrl()) {
  if (sessionExpired.value) return false

  loginUrl.value = url
  sessionExpired.value = true

  listeners.forEach((listener) => listener(loginUrl.value))
  return true
}

export function onSessionExpired(listener: SessionExpiredListener) {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export function resetSessionExpiredState() {
  sessionExpired.value = false
  loginUrl.value = '/Account/Login'
  listeners.clear()
}
